import styled from "styled-components";
import { palette } from "styled-theme";

const ActionsTableWrapper = styled.div`
  &.borderless {
    border: none;
    padding: 0;
  }
  background-color: ${palette("surfaceColor", 0)};
  .disabled {
    &.ant-table-row {
      opacity: 0.5;
    }
  }
  &.expandable {
    .ant-table-row-indent + .ant-table-row-expand-icon {
      display: flex;
    }
  }
  .table-row-warning {
    span {
      color: red;
      svg {
        color: initial;
      }
    }
  }
  .table-row-red-bg {
    background: #ff000014;
  }

  thead > tr > th {
    font-weight: 700;
  }
  .ant-table-row-indent + .ant-table-row-expand-icon {
    display: none;
  }
  .reloadRtl {
    transform: scaleX(-1);
  }
`;

export default ActionsTableWrapper;
